import styled from 'styled-components';

import Button from '@/components/button/Button';
import { colors } from '@/theme/colors';
import { useTranslation } from 'react-i18next';

interface ConfirmModalProps {
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}
const ConfirmModal = ({ message, onConfirm, onCancel }: ConfirmModalProps) => {
  const { t } = useTranslation();
  return (
    <BackDrop>
      <ModalBox>
        <Message>{message}</Message>
        <ButtonRow>
          <Button
            text={t('cancel')}
            onClick={onCancel}
            variant="secondary"
            size="medium"
          />
          <Button
            text={t('confirm')}
            onClick={onConfirm}
            variant="primary"
            size="medium"
          />
        </ButtonRow>
      </ModalBox>
    </BackDrop>
  );
};

export default ConfirmModal;

const BackDrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: ${colors.overlay};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 0 15px;
`;

const ModalBox = styled.div`
  background: ${colors.white};
  padding: 25px 30px;
  border-radius: 15px;
  max-width: 320px;
  width: 100%;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
`;

const Message = styled.div`
  font-weight: 700;
  font-size: 18px;
  line-height: 160%;
  margin-bottom: 24px;
  white-space: pre-line;
  color: ${colors.black};
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: space-around;
  gap: 12px;
`;
